import styles from './styles.module.scss';

import cn from 'classnames';


const H1 = props => (
  <h1 className={cn(styles.h1, props.styles)} style={props.style}>
    {props.children}
  </h1>
);

export default H1;
